import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
